import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  d: "M7.748 38.217c0 2.724-1.065 3.696-3.971 3.696H0v5.642h2.808c7.312 0 10.654-3.113 10.654-9.97V13.558H7.748v24.659z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.834 2.715c.004-.06.009-.12.009-.18A2.53 2.53 0 0 0 9.319 0 2.526 2.526 0 0 0 6.817 2.22a3.266 3.266 0 0 0-2.691 3.219A3.263 3.263 0 0 0 7.193 8.7a4.029 4.029 0 0 0 3.447 1.95c2.23 0 4.039-1.817 4.039-4.058a4.057 4.057 0 0 0-2.845-3.877"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E6AAF",
  d: "M9.32 0a2.526 2.526 0 0 0-2.503 2.219A2.529 2.529 0 0 0 7.4 4.177a2.509 2.509 0 0 0 3.164.561 2.531 2.531 0 0 0 1.27-2.023c.005-.06.01-.12.01-.18A2.53 2.53 0 0 0 9.319 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#49C2C6",
  d: "M11.834 2.715a4.016 4.016 0 0 0-2.56.063 4.048 4.048 0 0 0-1.875 1.399A4.047 4.047 0 0 0 7.193 8.7a4.029 4.029 0 0 0 3.447 1.95c2.23 0 4.039-1.817 4.039-4.058a4.057 4.057 0 0 0-2.845-3.877"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3B5AA9",
  d: "M9.273 2.778a3.267 3.267 0 0 1 1.29 1.96 2.535 2.535 0 0 0 1.27-2.023 4.013 4.013 0 0 0-2.56.062"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9695C9",
  d: "M10.563 4.738a3.272 3.272 0 0 0-3.18-2.571 3.266 3.266 0 0 0-3.257 3.272A3.263 3.263 0 0 0 7.193 8.7c.063.004.126.01.19.01a3.264 3.264 0 0 0 3.18-3.972"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C5CA8",
  d: "M7.4 4.177a4.04 4.04 0 0 1 1.874-1.4 3.232 3.232 0 0 0-1.892-.61c-.193 0-.38.02-.565.052A2.529 2.529 0 0 0 7.4 4.177"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0F7AC0",
  d: "M10.64 5.438c0-.24-.028-.474-.077-.7A2.512 2.512 0 0 1 7.4 4.177a4.045 4.045 0 0 0-.206 4.524c.063.004.126.01.19.01 1.799 0 3.257-1.465 3.257-3.272"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3C4CA0",
  d: "M9.273 2.778A4.046 4.046 0 0 0 7.4 4.177a2.513 2.513 0 0 0 3.164.562 3.267 3.267 0 0 0-1.29-1.961"
}));
export default (function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "48",
    viewBox: "0 0 15 48"
  }, props), _ref);
});